import axios from 'axios';
import { CONFIG } from '../config.js';
import {
    acquireCancelSignal,
    isRequestCancelled,
    releaseCancelSignal,
} from './requestCancellation.js';

export { isRequestCancelled } from './requestCancellation.js';

export const methods = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
};

const buildUrl = (path) => {
    const trimmedPath = path.replace(/^\//, '');
    const normalizedPath = trimmedPath.startsWith('v1/') ? trimmedPath : `v1/${trimmedPath}`;
    return `${CONFIG.api_base_url}${normalizedPath}`;
};

const getErrorMessage = (error) => {
    if (!error?.data) {
        return 'An unexpected error occurred';
    }

    if (typeof error.data.detail === 'string') {
        return error.data.detail;
    }

    if (error.data.error?.msg) {
        return error.data.error.msg;
    }

    if (typeof error.data.message === 'string') {
        return error.data.message;
    }

    return 'An error occurred while processing your request';
};

export async function request(path, method = methods.POST, data, config = {}) {
    const { cancelKey, ...axiosConfig } = config;
    let controller;
    if (cancelKey) {
        controller = acquireCancelSignal(cancelKey);
    }

    try {
        const response = await axios({
            url: buildUrl(path),
            method,
            data,
            withCredentials: true,
            signal: controller?.signal,
            ...axiosConfig,
        });
        if (cancelKey) {
            releaseCancelSignal(cancelKey, controller);
        }
        return [null, response];
    } catch (error) {
        if (cancelKey) {
            releaseCancelSignal(cancelKey, controller);
        }
        if (isRequestCancelled(error)) {
            const cancelled = error.response || { data: { message: 'canceled' } };
            cancelled.cancelled = true;
            cancelled.message = 'canceled';
            return [cancelled, null];
        }
        const normalizedError = error.response || { data: { message: error.message } };
        normalizedError.message = getErrorMessage(normalizedError);
        return [normalizedError, null];
    }
}
